import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=682dde48&scoped=true"
import script from "./Icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./Icon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Icon.vue?vue&type=style&index=0&id=682dde48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682dde48",
  null
  
)

export default component.exports